export interface Testimonial {
  id: number;
  name: string;
  avatar: string;
  content: string;
  rating: number;
  product: string;
  date: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: '棉花糖小姐',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20minimal%20profile%20avatar%20illustration%20of%20a%20young%20woman%20with%20warm%20smile%2C%20soft%20pastel%20colors%2C%20cream%20background%2C%20kawaii%20style%20portrait&width=100&height=100&seq=avatar-01&orientation=squarish',
    content: '第一眼看到黄油小熊就被治愈了！毛绒玩偶的手感超级好，每天抱着睡觉已经成为习惯。已经集齐了三款不同尺寸的，准备继续收集下去！',
    rating: 5,
    product: '经典毛绒玩偶',
    date: '2024-11-20',
  },
  {
    id: 2,
    name: '小熊软糖',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20minimal%20profile%20avatar%20illustration%20of%20a%20young%20girl%20with%20ponytail%2C%20soft%20pastel%20colors%2C%20cream%20background%2C%20kawaii%20style%20portrait&width=100&height=100&seq=avatar-02&orientation=squarish',
    content: '盲盒系列太惊喜了！每一款都精致得不行，隐藏款也抽到了，开心到飞起！展示盒也超实用，放在书桌上每天看到心情都会变好。',
    rating: 5,
    product: '限定盲盒系列',
    date: '2024-12-05',
  },
  {
    id: 3,
    name: '暖阳同学',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20minimal%20profile%20avatar%20illustration%20of%20a%20young%20man%20with%20glasses%2C%20soft%20pastel%20colors%2C%20cream%20background%2C%20kawaii%20style%20portrait&width=100&height=100&seq=avatar-03&orientation=squarish',
    content: '送给女朋友的生日礼物，她开心得哭了哈哈。黄油小熊真的是送礼神器，颜值在线品质也在线，以后节日礼物就锁定你家了！',
    rating: 5,
    product: '暖绒抱枕',
    date: '2024-12-18',
  },
  {
    id: 4,
    name: '草莓奶油蛋糕',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20minimal%20profile%20avatar%20illustration%20of%20a%20young%20woman%20with%20short%20hair%2C%20soft%20pastel%20colors%2C%20cream%20background%2C%20kawaii%20style%20portrait&width=100&height=100&seq=avatar-04&orientation=squarish',
    content: '手账本简直是为我量身定做的！纸张质量很好，小熊插画太太太可爱了。每天写手账都变成了一种享受，工作效率都提高了~',
    rating: 5,
    product: '治愈手账本',
    date: '2025-01-08',
  },
  {
    id: 5,
    name: '云朵收藏家',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20minimal%20profile%20avatar%20illustration%20of%20a%20young%20girl%20with%20twin%20tails%2C%20soft%20pastel%20colors%2C%20cream%20background%2C%20kawaii%20style%20portrait&width=100&height=100&seq=avatar-05&orientation=squarish',
    content: '联名保温杯太值了！颜值和实用性兼备，小熊耳朵杯盖设计太细节了。带去公司同事都问在哪买的，已经安利了好几个人入坑！',
    rating: 5,
    product: '联名保温杯',
    date: '2025-01-20',
  },
  {
    id: 6,
    name: '晚安小熊',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20minimal%20profile%20avatar%20illustration%20of%20a%20young%20woman%20with%20long%20hair%2C%20soft%20pastel%20colors%2C%20cream%20background%2C%20kawaii%20style%20portrait&width=100&height=100&seq=avatar-06&orientation=squarish',
    content: '小夜灯是我今年买过最满意的产品！三档亮度很实用，睡前调到最暗那档，看着小熊温暖的光慢慢入睡，失眠都改善了不少。',
    rating: 5,
    product: '桌面小夜灯',
    date: '2025-02-14',
  },
];